"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseNavigationModule = /** @class */ (function () {
    function FuseNavigationModule() {
    }
    return FuseNavigationModule;
}());
exports.FuseNavigationModule = FuseNavigationModule;
